import React from 'react';

export default function Loader(props) {
  return (
    <div class='container'>
      <div class='loader'></div>
    </div>
  );
}
